import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/platform/desa')({
  component: () => <Outlet />,
})
